export default {
  state:{

    crear:{
      derivaciones: [],
      interconsultas: []
    },

    registradas:{
      derivaciones:  [],
      interconsultas: []
    }
  },

  
  mutations: {

    setCrearDerivacionesInterconsultas(state, data){
      state.crear = data
    },

    setDerivacionesRegistradas(state, data){
      state.registradas.derivaciones = data
    },

    setInterconsultasRegistradas(state, data){
      state.registradas.interconsultas = data
    },


    resetDerivacionesInterconsultas(state){
      state.crear = {
        derivaciones: [],
        interconsultas: []
      }
      state.registradas = {
        derivaciones:  [],
        interconsultas: []
      }
    }
  }
}
    